export default "/kiban/_next/static/images/bottom_yellow-bee16381714c2016ff02eca0666dde41.png";